export const daysAgoDate = (
  date: Date | undefined,
  timeZone: string | undefined,
  includeTimeZoneInOutput: boolean,
): string[] => {
  if (date === undefined) {
    return []
  }

  const diffInMSecs = Date.now() - date.getTime()
  const diffInHours = Math.floor(diffInMSecs / 3600000)
  const diffInDays = Math.floor(diffInMSecs / 86400000)
  let retDat = null
  if (diffInDays > 1) {
    retDat = `${diffInDays} Days Ago`
  } else if (diffInDays === 1) {
    retDat = `1 Day Ago`
  } else if (diffInHours > 1) {
    retDat = `${diffInHours} Hours Ago`
  } else if (diffInHours === 1) {
    retDat = `1 Hour Ago`
  } else {
    retDat = `Moments Ago`
  }
  const dateFormatter = new Intl.DateTimeFormat(undefined, {
    dateStyle: 'short',
    timeZone: timeZone
  })
  const timeFormatter = new Intl.DateTimeFormat(undefined, {
    localeMatcher: undefined,
    weekday: undefined,
    era: undefined,
    year: undefined,
    month: undefined,
    day: undefined,
    hour: 'numeric',
    minute: '2-digit',
    second: undefined,
    timeZoneName: includeTimeZoneInOutput ? 'short' : undefined,
    formatMatcher: undefined,
    hour12: true,
    timeZone: timeZone
  })
  const time = timeFormatter.format(date)

  retDat = [retDat, `${dateFormatter.format(date)} ${time}`]
  return retDat
}


export const prettyDate = (
  date: Date | undefined,
  timeZone: string | undefined,
  includeTimeZoneInOutput: boolean,
  includeDate: boolean,
) => {
  //TODO allow timezone overrides
  if (date === undefined) {
    return ''
  }
  const dateWithoutTime = new Date(date)
  const today = new Date()
  const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000)
  const sixDaysAgo = new Date(today.getTime() - 6 * 24 * 60 * 60 * 1000)

  dateWithoutTime.setHours(0, 0, 0, 0)
  today.setHours(0, 0, 0, 0)
  yesterday.setHours(0, 0, 0, 0)
  sixDaysAgo.setHours(0, 0, 0, 0)

  const timeFormatter = new Intl.DateTimeFormat(undefined, {
    localeMatcher: undefined,
    weekday: undefined,
    era: undefined,
    year: undefined,
    month: undefined,
    day: undefined,
    hour: 'numeric',
    minute: '2-digit',
    second: undefined,
    timeZoneName: includeTimeZoneInOutput ? 'short' : undefined,
    formatMatcher: undefined,
    hour12: true,
    timeZone: timeZone
  })
  const time = timeFormatter.format(date)

  if (!includeDate) {
    return time
  } else if (dateWithoutTime.getTime() === today.getTime()) {
    return time
  } else if (dateWithoutTime.getTime() === yesterday.getTime()) {
    return `Yesterday ${time}`
  } else if (dateWithoutTime.getTime() > sixDaysAgo.getTime()) {
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    return `${weekdays[date.getDay()]} ${time}`
  } else {
    const dateFormatter = new Intl.DateTimeFormat(undefined, {
      dateStyle: 'short',
      timeZone: timeZone
    })
    return `${dateFormatter.format(date)} ${time}`
  }
}
